<template>
  <div>

    <v-toolbar flat>
      
      <v-toolbar-title>
        <small class="d-block primary--text"
               v-if="subtitle">
          {{ subtitle }}
        </small>
        {{ theModel.title }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn depressed
              @click="goBack">
        <v-icon>mdi-close</v-icon>
      </v-btn>

    </v-toolbar>

    <div v-if="theModel.canRead">

      <PdfViewer :url="theModel.pdf"
               v-if="theModel.pdf"/>

      <iframe :src="theModel.embed"
              class="reader"
              v-else-if="theModel.embed"/>
      
    </div>

  </div>
</template>

<style lang="scss">
  .reader {
    height: calc( 100vh - 55px );
    width: 100vw;
    border: 0;
  }
</style>

<script>
import API from '@/api'

import { mapActions, mapGetters, mapMutations } from 'vuex'

import slug from '@/mixins/slug'
import utility from '@/mixins/utility'

import PdfViewer from '@/components/PdfViewer'

export default {
  
  name: 'Reader',

  mixins: [ slug, utility ],

  components:
  {
    PdfViewer
  },

  data: () => ({
    theModel: {}
  }),

  computed:
  {
    ...mapGetters({
      isLoading: 'ui/isLoading'
    }),

    embedUrl()
    {
      if( this.theModel.pdf )
        return this.theModel.pdf

      else if( this.theModel.embed )
        return this.theModel.embed

      return ''
    },

    model()
    {
      return this.$route.params.model
    },
    
    modelType()
    {
      return this.$route.params.modelType
    },

    subtitle()
    {
      if( this.theModel.issue )
        return this.theModel.issue.title

      if( this.theModel.library )
        return this.theModel.library.title

      return ''
    }
  },

  methods: 
  {
    ...mapActions({
      hideFooter: 'ui/hideFooter',
      showFooter: 'ui/showFooter'
    }),

    ...mapMutations({
      setLoading: 'ui/setLoading'
    }),

    fetch()
    {
      this.setLoading(true)

      let params = { withPermissions: true }

      if( this.modelType === 'issue' )
        params.include = 'library'

      API[ this.modelType ]
        .one(this.slug, params)
        .then(({ data }) => {
          this.theModel = this.mapModel(data.data, this.modelType)
        })
        .catch(err => {
          console.error(err)
        })
        .finally(()=>this.setLoading(false))
    },

    goBack()
    {
      this.$router.back()
    },

    load()
    {
      if( this.model )
        this.theModel = this.model

      this.fetch()
    }
  },

  mounted()
  {
    this.load()

    this.setBack(null)

    this.hideFooter()
  },

  watch:
  {
    theModel(model)
    {
      if( !model.canRead )
        this.goTo('error')
    }
  }

}
</script>
